import { useState, useEffect } from "react";
import useSettingsStore from "@/store/SettingsStore";
import { RiResetRightLine } from "react-icons/ri";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";

function ChatSettings({ labelStyling }: { labelStyling: string }) {
  const setColorPalette = useSettingsStore(state => state.setColorPalette);
  const setIsChatNotificationOn = useSettingsStore(state => state.setIsChatNotificationOn);

  const isChatNotificationOn = useSettingsStore(state => state.isChatNotificationOn)
  const colorPalette = useSettingsStore(state => state.colorPalette)

  // Local state for debouncing color palette
  const [localColor, setLocalColor] = useState(colorPalette);

  // Debounce effect
  useEffect(() => {
    const timer = setTimeout(() => {
      if (localColor !== colorPalette) {
        setColorPalette(localColor); // Apply the change after the delay
      }
    }, 500); // 500ms debounce delay

    return () => clearTimeout(timer); // Clear the timeout on component unmount or when localColor changes
  }, [localColor, colorPalette, setColorPalette]);

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalColor(e.target.value);
  };

  return (
    <>
      <Label htmlFor="notification-on-chat" className={labelStyling}>
        <div className="space-y-1">
          <span className="text-sm font-medium">Get notification on new message</span>
          <p className="text-xs text-zinc-600 dark:text-zinc-400">You will get a notification on each new message if you minimized the app.</p>
        </div>
        <Switch id="notification-on-chat" checked={isChatNotificationOn} onCheckedChange={setIsChatNotificationOn} />
      </Label>

      <div className={labelStyling}>
        <div className="space-y-1">
          <span className="text-sm font-medium">Chat color palette</span>
          <p className="text-xs text-zinc-600 dark:text-zinc-400">This will display before your chat messages as a bar so you can identify your chat easily.</p>
        </div>

        <div className="flex space-x-2">
          {colorPalette !== "#dc2626" && (
            <button
              onClick={() => {
                setColorPalette("#dc2626");
                setLocalColor("#dc2626"); // Update local color as well
              }}
              type="button"
              className="w-8 h-8 flex justify-center items-center border-1 border-zinc-300 hover:bg-zinc-300 dark:border-zinc-700 dark:hover:bg-zinc-700 rounded-md"
            >
              <RiResetRightLine />
            </button>
          )}
          <label
            htmlFor="chat-color"
            className="w-8 h-8 border-1 border-zinc-300 dark:border-zinc-700 rounded-md"
            style={{ backgroundColor: localColor }}
          >
            <input
              type="color"
              id="chat-color"
              style={{
                backgroundColor: localColor,
              }}
              value={localColor}
              onChange={handleColorChange}
              className="h-8 w-8 cursor-pointer opacity-0 rounded-md overflow-hidden !border-none !outline-none p-0 m-0"
            />
          </label>
        </div>
      </div>
    </>
  );
}

export default ChatSettings;
